import React from "react";
import { Tooltip } from "antd";
import { PUBLIC_ASSETS_URL } from "../../config";

const LogoROI = () => {
  return (
    <Tooltip title="This data column is provided by Richardson Oliver Insights LLC" placement="right">
      <a href="https://roipatents.com/roi-deal-data">
        <img alt="ROI Logo" src={`${PUBLIC_ASSETS_URL}/ROI_logo.png`} height={17} />
      </a>
    </Tooltip>
  );
};

export default LogoROI;
